'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { trackCTAClick } from '@/lib/analytics';

const CTASection = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-primary via-primary/95 to-primary/90 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-golden-light to-golden-dark rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gradient-to-tr from-golden-mid to-golden-light rounded-full blur-3xl" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} className="text-golden-light" />
            <span className="text-sm font-semibold text-golden-light">Ready to Get Started?</span>
          </div>
          
          <h2 className="font-headline font-bold text-3xl lg:text-5xl text-white mb-6">
            Let's Build Your Logistics Solution
          </h2>
          
          <p className="font-body text-lg lg:text-xl text-white/90 mb-12 max-w-2xl mx-auto">
            Our team of logistics experts is ready to design a customized solution that meets your specific requirements across African markets.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/contact-and-quotes"
              onClick={() => trackCTAClick('Request a Quote', 'Services Overview', '/contact-and-quotes')}
              className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-golden-light to-golden-dark rounded-xl font-cta font-semibold text-primary shadow-golden-lg hover:shadow-golden-xl transition-all duration-300 hover:-translate-y-1"
            >
              <Icon name="DocumentTextIcon" size={20} />
              <span>Request a Quote</span>
            </Link>
            
            <Link
              href="/regional-coverage"
              onClick={() => trackCTAClick('Explore Coverage', 'Services Overview', '/regional-coverage')}
              className="inline-flex items-center space-x-2 px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 rounded-xl font-cta font-semibold text-white hover:bg-white/20 transition-all duration-300"
            >
              <Icon name="MapIcon" size={20} />
              <span>Explore Coverage</span>
            </Link>
          </div>
          
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-golden-light to-golden-dark flex items-center justify-center">
                  <Icon name="ClockIcon" size={24} className="text-primary" />
                </div>
              </div>
              <div className="font-headline font-bold text-2xl text-golden-light mb-2">
                24/7
              </div>
              <div className="font-body text-sm text-white/80">
                Support Available
              </div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-golden-light to-golden-dark flex items-center justify-center">
                  <Icon name="ShieldCheckIcon" size={24} className="text-primary" />
                </div>
              </div>
              <div className="font-headline font-bold text-2xl text-golden-light mb-2">
                100%
              </div>
              <div className="font-body text-sm text-white/80">
                Compliance Guaranteed
              </div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-golden-light to-golden-dark flex items-center justify-center">
                  <Icon name="TruckIcon" size={24} className="text-primary" />
                </div>
              </div>
              <div className="font-headline font-bold text-2xl text-golden-light mb-2">
                500+
              </div>
              <div className="font-body text-sm text-white/80">
                Fleet Vehicles
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;